/**
 * Created by ma.rongqin on 2016/2/15.
 */
'use strict';
angular.module("manConSysSouCenClassifyMgrModule",[
    "sysmanageSouCenClassifyMgrRouterModule",
    'manConSysSouCenClassifyMgrServiceModule',
    "manConSysSouCenSiteRecycleModule",
    "manConSysSouCenClassifyMgrChnnlMgrModule",
])
    .controller("manConSysSouCenClassifyMgrCtrl",['$scope',"trsHttpService","manConSysSouCenClassifyMgrService","modalDialog",function($scope,trsHttpService,manConSysSouCenClassifyMgrService,modalDialog){
        $scope.modifyViews = function(){
            var params = {
                title:"站点管理-修改站点",
                type:"渠道"
            };
            manConSysSouCenClassifyMgrService.modifyViews(params,function(){

            });
        }
        $scope.addViews = function(){
            var params = {
                title:"新增渠道",
                type:"渠道"
            };
            manConSysSouCenClassifyMgrService.modifyViews(params,function(){

            });
        };
        $scope.deleteViews = function(){
            modalDialog.inputModel("确认删除此渠道", "输入删除的理由，可选填！", function(content) {

            });
        }
    }]);